import { ISocialNetworks } from './profile';
import * as moment from 'moment';
import { Moment } from 'moment';

export interface ICompanyData {
  address?: string;
  name?: string;
  position?: string;
  license?: string;
  date_start?: string;
  web_site?: string;
  country?: string;
  city?: string;
  email?: string[];
  phone?: string[];
  social_networks?: ISocialNetworks;
  comment?: string;
  photo?: string;
}

export class CompanyData {
  address: string;
  name: string;
  position: string;
  photo: string;
  date_start: Moment;
  license: string;
  web_site: string;
  country: string;
  city: string;
  comment: string;
  email: string[];
  phone: string[];
  social_networks: ISocialNetworks;

  constructor( data: ICompanyData = {} ) {
    this.address = data.address || '';
    this.name = data.name || '';
    this.position = data.position || '';
    this.date_start = data.date_start ? moment(data.date_start) : null;
    this.license = data.license || '';
    this.web_site = data.web_site || '';
    this.email = data.email || [];
    this.phone = data.phone || [];
    this.social_networks = data.social_networks || {};
    this.country = data.country;
    this.city = data.city;
    this.comment = data.comment;
    this.photo = data.photo;
  }
}



// WEBPACK FOOTER //
// ./app/core/entities/company-data.ts